import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Box = styled.nav`
  margin-top: 2.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
`;

const Heading = styled.h2`
  font-size: 1.2rem;
  margin: 0 0 0.75rem;
  color: var(--my-color3);
`;

const List = styled.ul`
  margin: 0;
  padding-left: 1.2rem;
  line-height: 1.8;
`;

const Item = styled.li`
  margin-bottom: 0.35rem;
  & a {
    color: var(--my-color3);
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
  & a:hover {
    color: var(--my-color2);
  }
`;

export default function SeoInternalLinks({ title = "À lire aussi", links }) {
  if (!links?.length) return null;
  return (
    <Box aria-label={title}>
      <Heading>{title}</Heading>
      <List>
        {links.map(({ to, label }) => (
          <Item key={to}>
            <Link to={to}>{label}</Link>
          </Item>
        ))}
      </List>
    </Box>
  );
}
